// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CheckInCircle from '../_raw/ui/icon_check_in_circle.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CheckInCircle);
